import { FC, ReactNode, useEffect } from 'react';
import ProgressBar from './ProgressBar';
import useOnboardingStore from 'stores/onboardingStore';
import { steps } from './SequenceSteps';

const OnboardingSequence = () => {
  const { progressStep, setPercentCompleted, rotateVault } =
    useOnboardingStore();

  useEffect(() => {
    setPercentCompleted(steps[progressStep].progressOnMount);
    rotateVault(50);
  }, [progressStep]);

  return (
    <>
      {progressStep === 0 ? (
        <div className="grid w-full h-full grid-rows-[1fr_auto] gap-[30px] pb-[30px]">
          {steps[progressStep].component}
          <div>
            <ProgressBar />
          </div>
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center w-full h-full gap-[30px] py-[30px]">
          {steps[progressStep].component}
          {/* <div> */}
          <ProgressBar />
          {/* </div> */}
        </div>
      )}
    </>
  );
};

export const SequenceItem: FC<{
  children: ReactNode;
  progressStep?: number;
}> = ({ children, progressStep }) => (
  <div
    className={
      progressStep === 0
        ? 'grid w-full h-full grid-rows-[1fr_auto] gap-[30px]'
        : 'flex flex-col items-center w-full h-fit gap-[30px]'
    }
  >
    {children}
  </div>
);

export default OnboardingSequence;
